import React from 'react';
import { cn } from '@/lib/utils';
import { getProfileBadgeLabel } from '../../utils/companionProfiles';

/**
 * Gentle profile-type badge for person detail and list cards.
 */
export function CompanionBadge({ person, className }) {
  const label = getProfileBadgeLabel(person);
  if (!label) return null;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-[hsl(38_14%_82%)] bg-[hsl(42_26%_97%)] px-2.5 py-0.5 text-[0.65rem] font-medium uppercase tracking-[0.12em] text-[hsl(32_12%_38%)]',
        className
      )}
      data-testid="companion-profile-badge"
    >
      {label}
    </span>
  );
}
